import '../javascripts/common/initializers/rails.js'
import { Turbo } from '@hotwired/turbo-rails'
import { Ienavi } from '../javascripts/common/ienavi.js'

// turbo drive は使用しないので無効化
Turbo.session.drive = false

const components = import.meta.glob(
  [
    // 対象ディレクトリと拡張子をglobで指定
    '@/javascripts/{common,ienavi-admin}/**/*.{vue,ts}',
    // 除外するファイルを否定パターンで指定
    '!**/*.spec.{vue,ts}'
  ],
  { eager: true }
)

Ienavi.start(components)
